import type { OrderItem } from "@jti/magento";

import type { SummaryItem } from "@checkout-v2/features/ItemsSummary/ItemsSummaryView";

export const mapSimpleOrderItemToSummaryItem = (
  orderItem: OrderItem,
  showPricesWithTaxExcluded: boolean
): SummaryItem => {
  const badge = orderItem.isGift ? "cart.payment_summary.freeGift" : undefined;
  const priceToUse = showPricesWithTaxExcluded ? orderItem.productSalePrice : orderItem.productSalePriceInclTax;
  return {
    type: "product",
    id: orderItem.item_id || orderItem.sku,
    item: {
      thumbnail: {
        src: orderItem.imageUrl ?? "",
        alt: orderItem.name,
      },
      title: orderItem.name,
      spec: undefined,
      badge: badge,
      quantity: orderItem.quantity,
      price: {
        value: priceToUse?.value ?? 0,
        currency: priceToUse?.currency ?? "",
      },
      nicotineStrength: orderItem.nicotineStrength,
    },
  };
};
